exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".star-color {\n  color: #ffbf00;\n}\n.link-list {\n  background: black;\n  color: #fff;\n}\n.link-list a {\n  color: #fff;\n}\n.link-list a:hover {\n  text-decoration: none;\n  color: #fff;\n}\n.legal {\n  color: #1e1e2d;\n  background: #eceaea;\n}\n.legal a {\n  color: #1e1e2d;\n}\n.legal a:hover {\n  text-decoration: none;\n  color: #1e1e2d;\n}\n.sticky-contact-button {\n  position: fixed;\n  bottom: 20px;\n  left: 20px;\n  z-index: 1040;\n}\n.paymentIcons {\n  padding-right: 1.5rem;\n  margin-bottom: 1rem;\n  width: 80px;\n}", ""]);

// exports
